import React, { Component } from 'react'
import { connect } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { bindActionCreators } from 'redux';
import jsPDF from "jspdf";
import "jspdf-autotable";
import axios from 'axios';
import Select from 'react-select';
import Chart from 'react-apexcharts'
import { AC_LIST_FEEDBACK } from '../../../actions/reviewAction';
import { AC_LIST_HOTEL } from '../../../actions/hotelAction';
import ImportedURL from '../../../common/api';
import moment from 'moment';
import { Error, Success } from '../../../common/swal';
import { Link } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import { AC_LIST_ROOM } from '../../../actions/roomAction';
import { CapitalizeFirstLetter } from '../../../common/validate';
import Swal from 'sweetalert2';


const initialState = {
    modalType: "Add",
    columnDefs: [
        {
            headerName: 'Room', field: 'room_number', width: 100, floatingFilter: true,

        },
        { headerName: 'Name', field: 'name', width: 100, floatingFilter: true },
        {
            headerName: 'Phone No.', field: 'contact', width: 200, cellStyle: { 'text-align': 'center' }, floatingFilter: true,
        },
        {
            headerName: 'Status', width: 200, field: 'status', sortable: true, cellStyle: { 'text-align': 'center' }, filter: true,
            valueGetter: function (params) {
                // { negative_clicked: true }, { clicked_google: true }, { clicked_tripadvisor: true }
                if (params.data.negative_clicked || params.data.clicked_google || params.data.clicked_tripadvisor) return 'Opened';
                else if (params.data.status == 'valid') return 'Valid';
                else if (params.data.status == 'invalidphone') return 'Invalid phone number';
                else if (params.data.status == 'nophone') return 'No phone number';
                else if (params.data.status == 'repeated') return 'Repeated phone number';
                else if (params.data.status == 'noroom') return 'Cancelled';
                else if (params.data.status == 'blocklist') return 'Block list';
                else return params.data.status;
            }
        },
        {
            headerName: 'Message Status', width: 200, field: 'sms_status', sortable: true, cellStyle: { 'text-align': 'center' }, filter: true,
            valueGetter: function (params) {
                if (params.data.sms_status) {
                    return CapitalizeFirstLetter(params.data.sms_status)
                } else {
                    return '---'
                }
            }
        },
    ],
    columnDefs2: [
        {
            headerName: 'Room', field: 'roomno', width: 100, floatingFilter: true,
            valueGetter: function (params) {
                if (params.data.roomno) {
                    let value = ''
                    if (params.data.roomData && params.data.roomData.length) {
                        params.data.roomData.map((item) => {
                            if (item._id == params.data.roomno) {
                                value = item.room
                            }
                        })
                    }
                    if (value) {
                        return value
                    } else {
                        return params.data.roomno
                    }
                } else {
                    return "---"
                }
            }
        },
        { headerName: 'Name', field: 'name', width: 100, floatingFilter: true },
        {
            headerName: 'Phone No.', field: 'phone', width: 200, cellStyle: { 'text-align': 'center' }, floatingFilter: true,
            valueGetter: function (params) {
                if (params.data.phone) {
                    if (params.data.cc.includes("+")) {
                        return `${params.data.cc + ' '}${params.data.phone}`;
                    } else {
                        return `${"+" + params.data.cc + ' '}${params.data.phone}`;
                    }
                } else {
                    return "---"
                }
            }
        },

        {
            headerName: 'Action', width: 120, sortable: false, filter: false, cellStyle: { 'text-align': 'center' }, headerClass: 'ag-center-header', suppressMenu: true, sortable: false, filter: false,
            template:
                `<span type="button" class="tag tag-danger" data-action-type="Cancel"><i class='fa fa-close mr-2 mt-2'></i>Cancel</span>`,
        },
    ],
    defaultColumDef: {
        "width": 200,
        "filter": true,
        "sortable": true,
        "resizable": true
    },
    defaultColumDef2: {
        editable: false,
        sortable: true,
        resizable: true,
        filter: true,
        flex: 1,
        minWidth: 100,
    },
    feedbacks: [],
    orignalData: [],
    hotel: '',
    gridView: false,
    selectedHotel: '',
    sent: 0,
    seen: 0,
    total: 0,
    options: {
        chart: {
            toolbar: {
                show: true,
                tools: {
                    download: true // <== line to add
                }
            },
            events: {
                mouseLeave: function (event, chartContext, config) {
                    chartContext.resetSeries()
                }
            }
        },
        dataLabels: {
            formatter: function (val, opts) {
                return opts.w.config.series[opts.seriesIndex]
            },
        },
        labels: ['Sent', 'Opened', 'Unopened', 'No phone number', 'Invalid phone number', 'Cancelled', 'Repeated phone', "Block list", "Missing phone number"],
    },
    options1: {
        chart: {
            toolbar: {
                show: true,
                tools: {
                    download: true // <== line to add
                }
            },
            events: {
                mouseLeave: function (event, chartContext, config) {
                    chartContext.resetSeries()
                }
            }
        },
        dataLabels: {
            formatter: function (val, opts) {
                return opts.w.config.series[opts.seriesIndex]
            },
        },
        labels: ['Completed with google', 'Completed with tripadvisor', 'Negative feedback'],
    },
    series: [],
    series1: [],
    reviews: [],
    month: '',
    initial: true,
    feedbackData: {},
    hotelName: '',
    selectedOption: '',
    hideReset: false,
    toDateReport: '',
    fromDateReport: "",
    toDate: '',
    spinner: false,
    google: '',
    tripadvisor: '',
    emptyStatus: false,
    queuelist: [],
    pagination: 1,
    paginationLimit: 2,
    startLimit: 1,
    endLimit: 2,
    queueshow: false,
    viewgooTripUrl: '',
    sendallbuttonshow: true,
}

class ListFeedback extends Component {
    constructor(props) {
        super(props);
        this.state = initialState;
    }


    // Pagination starts
    previousPage = (e) => {
        const { pagination, paginationLimit, startLimit, endLimit } = this.state
        if (1 < pagination) {
            this.setState({ startLimit: startLimit - paginationLimit, endLimit: endLimit - paginationLimit, pagination: pagination - 1 })
        }
    }
    nextPage = (e) => {
        const rowData = this.state.queuelist;
        const { pagination, paginationLimit, startLimit, endLimit } = this.state
        if (endLimit < rowData.length) {
            this.setState({ startLimit: endLimit + 1, endLimit: endLimit + paginationLimit, pagination: pagination + 1 })
        }
    }
    firstPage = (e) => {
        const { pagination, paginationLimit, startLimit, endLimit } = this.state
        if (1 < pagination) {
            this.setState({ startLimit: 1, endLimit: paginationLimit, pagination: pagination - 1 })
        }
    }
    lastPage = (e) => {
        const rowData = this.state.queuelist;
        const { pagination, paginationLimit, startLimit, endLimit } = this.state
        var totalNumber = Math.ceil(rowData.length / paginationLimit)
        if (endLimit < rowData.length) {
            this.setState({ startLimit: (totalNumber * paginationLimit) - paginationLimit, endLimit: (totalNumber * paginationLimit), pagination: totalNumber })
        }
    }

    // Pagination Ends


    onRowClicked = event => {
        const rowValue = event.event.target;
        const value = rowValue.getAttribute('data-action-type');
        if (value === 'View') {
            // window.open('/view-job/' + event.data._id, '_blank').focus();
            this.setState({ feedbackData: event.data })
        }
        if (value == 'Cancel') {
            let id = event.data._id;
            let hotel = this.state.selectedHotel;
            Swal.fire({
                title: 'Are you sure want to cancel review request?',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                imageUrl: 'assets/images/delete.png',
                customClass: {
                    popup: 'swal_pop',
                    title: 'swal_title',
                    image: 'swal_image',
                    actions: 'swal_action',
                    confirmButton: 'swal_confirm',
                    cancelButton: 'swal_close',
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post(ImportedURL.API.deleteQueue + '/' + hotel, {}, { params: { queueid: id, type: 'guesttouch' } })
                        .then((res) => {
                            if (res.data) {
                                this.setState({
                                    queuelist: res.data
                                })
                                if (res.data.length == 0) this.setState({
                                    queueshow: false
                                })
                            }
                        }).catch((err) => {
                            this.setState({ spinner: false })
                            console.log(err);
                        });
                }
            })
        }
    }

    onGridReady = (params) => {
        this.gridColumnApi = params.columnApi;
        this.gridApi = params.api;
        this.gridApi.sizeColumnsToFit();
    }

    generateColumnsForExcel() {
        const keys = this.gridColumnApi
            .getAllDisplayedColumns()
            .map(column => column.getColId())
        return keys;
    }
    exportToCSV = () => {
        const account = this.props.AccountState.account;
        this.gridApi.exportDataAsCsv({
            // columnKeys: this.generateColumnsForExcel(),
            columnKeys: ['hotel.name', 'roomno', 'name', 'contact', 'createdAt', 'status', 'sms_status'],
            fileName: "review-reports" + "_" + (this.state.hotelName && (this.state.hotelName).replace(/ /g, '_')) + (account.currentTime).replace(/ /g, '_') + ".csv",
            processCellCallback: function (params) {
                return params.value;
            }
        })
    }

    generateColumnsForExcel() {
        const keys = this.gridColumnApi
            .getAllDisplayedColumns()
            .map(column => column.getColId())
        return keys;
    }

    exportPDF = () => {
        const roomData = this.props.RoomState.listrooms;
        const account = this.props.AccountState.account;
        var dtFormat = (account.dateformate != '' ? account.dateformate : 'MM/DD/YYYY') + "  " + (account.timeformat != '' ? account.timeformat : "hh:mm A")
        var tzone = 'America/chicago'
        if (account != undefined && account && account.tzone != undefined && account.tzone) {
            tzone = account.tzone
        }
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "landscape"; // portrait or landscape

        const marginLeft = 15;
        const doc = new jsPDF(orientation, unit, size);

        var img = new Image();
        img.src = '../../assets/images/logo.png';

        doc.setFontSize(15);

        const title = (this.state.hotelName) ? (this.state.hotelName != "All" ? this.state.hotelName + " - Report List" : "Report List") : "Report List";
        if (this.state.hotelName) {
            var headers = [['#',
                "Room No.",
                'Name',
                'Email',
                "Phone No.",
                'Status',
                'Message Status',
                'Sent On']];

            var data = this.state.reviews.map((elt, i) => {
                // let value = ''
                // if (roomData && roomData.length) {
                //     roomData.map((item) => {
                //         if (item._id == elt.roomno) {
                //             value = item.room
                //         }
                //     })
                // }
                // if (value) {
                //     value = value
                // } else {
                //     value = elt.roomno
                // }
                let status = ''
                if (elt.seen) status = 'Opened';
                else if (elt.status == 'valid') status = 'Sent';
                else if (elt.status == 'invalidphone') status = 'Invalid phone number';
                else if (elt.status == 'nophone') status = 'No phone number';
                else if (elt.status == 'repeated') status = 'Repeated phone number';
                else if (elt.status == 'noroom') status = 'Cancelled';
                else if (elt.status == 'blocklist') status = 'Block list';
                else status = elt.status;
                return [
                    i + 1,
                    elt.roomno ? elt.roomno : '--',
                    elt.name ? elt.name : '---',
                    elt.email ? elt.email : '---',
                    elt.contact ? elt.contact : "---",
                    elt.status ? status : "---",
                    elt.sms_status ? CapitalizeFirstLetter(elt.sms_status) : "---",
                    moment(elt.date_text_sent).format(dtFormat),
                ]
            });
        }
        else {
            var headers = [['#',
                "Hotel",
                "Room No.",
                'Name',
                'Email',
                "Phone No.",
                "Message",
                'Status',
                'Message Status',
                'Created At']];

            var data = this.state.reviews.map((elt, i) => {
                // let value = ''
                // if (roomData && roomData.length) {
                //     roomData.map((item) => {
                //         if (item._id == elt.roomno) {
                //             value = item.room
                //         }
                //     })
                // }
                // if (value) {
                //     value = value
                // } else {
                //     value = elt.roomno
                // }
                let status = ''
                if (elt.seen) status = 'Opened';
                else if (elt.status == 'valid') status = 'Sent';
                else if (elt.status == 'invalidphone') status = 'Invalid phone number';
                else if (elt.status == 'nophone') status = 'No phone number';
                else if (elt.status == 'repeated') status = 'Repeated phone number';
                else if (elt.status == 'noroom') status = 'Cancelled';
                else if (elt.status == 'blocklist') status = 'Block list';
                else status = elt.status;
                return [
                    i + 1,
                    elt.hotel ? `${elt.hotel.name} ${elt.hotel.city} ${elt.hotel.state}` : '',
                    elt.roomno ? elt.roomno : '--',
                    elt.name ? elt.name : '---',
                    elt.email ? elt.email : '---',
                    elt.phone ? ((elt.cc ? elt.cc : '') + " " + elt.phone) : "---",
                    elt.messagedata ? elt.messagedata : "---",
                    elt.status ? status : "---",
                    elt.messageStatus ? CapitalizeFirstLetter(elt.messageStatus) : "---",
                    moment(elt.createdAt).format(dtFormat),
                ]
            });
        }


        let content = {
            startY: 70,
            head: headers,
            headStyles: { fillColor: [215, 234, 255], textColor: [28, 48, 120], },
            body: data,
            styles: {
                rowHeight: 30,
                valign: 'middle',
                lineWidth: 0.5,
            },
            margin: {
                left: 10,
                right: 10,
                bottom: 70,
            },
            autoPaging: "text",
        };
        doc.addImage(img, 'png', 780, 6, 50, 50);
        doc.setTextColor(28, 48, 120);
        doc.text(title, marginLeft, 40);
        doc.setTextColor(28, 48, 120);
        // doc.text('MyHotel AI', 710, 40)
        doc.autoTable(content);
        var totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            if (this.state.hotelName) {
                doc.setFontSize(11);
                doc.setTextColor(110);
                doc.text(account.hotelNameExport, 20, 545);
                doc.setFontSize(11);
                doc.setTextColor(110);
                doc.text(account.hoteladdressExport, 20, 560);
            }
            doc.setPage(i);
            doc.setFontSize(11);
            doc.setTextColor(110);
            doc.text('Page ' + i + ' of ' + totalPages, doc.internal.pageSize.getWidth() - 100, doc.internal.pageSize.getHeight() - 20);
            doc.setFontSize(11);
            const fullText = 'This is an auto-generated report from MyHotel AI (www.myhotelai.com)';
            const coloredText = '(www.myhotelai.com)';
            const textColor = [28, 48, 120]; // Specify your desired text color as an RGB array

            const textXPosition = 20;
            const textYPosition = 575;

            // Calculate the width of the full text before the colored text
            const fullTextWidth = doc.getTextWidth(fullText);
            const coloredTextWidth = doc.getTextWidth(coloredText);
            const leadingText = fullText.slice(0, fullText.indexOf(coloredText));

            // Render the leading text with default color
            doc.setTextColor(110); // Set default text color
            doc.text(leadingText, textXPosition, textYPosition);

            // Render the colored text with the specified color
            doc.setTextColor(textColor[0], textColor[1], textColor[2]);
            doc.text(coloredText, textXPosition + fullTextWidth - coloredTextWidth, textYPosition);
        }
        doc.save("review-reports" + "_" + (this.state.hotelName && (this.state.hotelName).replace(/ /g, '_')) + (account.currentTime).replace(/ /g, '_') + ".pdf")
    }

    componentWillUpdate(nextProps) {
        const newaccount = nextProps.AccountState.account;
        if (this.state.initial) {
            if (nextProps.AccountState.role !== 'admin') {
                this.setState({ selectedHotel: newaccount.hotel, toDateReport: '', month: '', spinner: true, });
                const formData = {
                    fromDate: this.state.fromDateReport ? this.state.fromDateReport + "T00:00:00" : '',
                    toDate: '',
                }
                this.getAllData(formData, newaccount.hotel)

                // axios.post(ImportedURL.API.getGuestReport + '/' + newaccount.hotel, formData)
                //     .then((res) => {
                //         if (res.data.reviews != undefined && res.data.reviews.length == 0 && this.state.gridView) {
                //             this.setState({ emptyStatus: true })
                //         } else {
                //             if (this.state.gridView)
                //                 this.setState({ emptyStatus: true })
                //             else
                //                 this.setState({ emptyStatus: false })
                //         }
                //         if (res.data) {
                //             const { total, seen, sent, nophone, repeated, invalidphone, noroom, blocklist, reviews, negativefeedbackstatus, tripadvisor, google, viewgooTripUrl } = res.data
                //             this.setState({
                //                 sent: sent, seen: seen, nophone, repeated, invalidphone, noroom, blocklist, total, reviews, spinner: false,
                //                 series: [sent, seen, sent - seen, nophone, invalidphone, noroom, repeated, blocklist]
                //             })
                //             this.setState({
                //                 google: google, tripadvisor: tripadvisor, negativefeedbackstatus: negativefeedbackstatus, viewgooTripUrl: viewgooTripUrl,
                //                 series1: [google, tripadvisor, negativefeedbackstatus]
                //             })
                //         }
                //     }).catch((err) => {
                //         this.setState({ spinner: false })
                //         console.log(err);
                //     });
            }
            this.setState({ initial: false })
        }
    }
    handleHotelChange = (e) => {
        const formData = {
            toDate: this.state.toDateReport ? this.state.toDateReport + "T23:59:59" : '',
            fromDate: this.state.fromDateReport ? this.state.fromDateReport + "T00:00:00" : ''
        }
        this.setState({ selectedHotel: e.value, hotelName: e.label, toDateReport: '', month: '', selectedOption: e, hideReset: true, spinner: true, });
        this.getAllData(formData, e.value, true)

    };

    setDateReport = (e) => {
        const { name, value } = e.target;
        if (this.state.selectedHotel) {
            let hotelId = this.state.selectedHotel;
            if (name == 'fromDateReport') {
                this.setState({ fromDateReport: value, toDateReport: '', month: '', hideReset: true });
                const formData = {
                    fromDate: value ? value + "T00:00:00" : '',
                    toDate: '',
                }
                this.setState({ spinner: true })
                this.getAllData(formData, hotelId)

            }
            if (name == 'toDateReport') {
                this.setState({ toDateReport: value, month: '', hideReset: true });
                const formData = {
                    toDate: value ? value + "T23:59:59" : '',
                    fromDate: this.state.fromDateReport ? this.state.fromDateReport + "T00:00:00" : ''
                }
                this.setState({ spinner: true })
                this.getAllData(formData, hotelId)
            }
        } else {
            Error("Select a hotel");
        }
    }

    componentDidMount() {
        const account = this.props.AccountState.account;
        this.setState({ hotelName: account.hotelName ? account.hotelName : '' });

        var today = new Date()
        var todayDate = moment(today).format("YYYY-MM-DD");
        this.setState({ fromDateReport: todayDate });

    }

    getMonths = (mon) => {
        let date = new Date();
        date.setDate(1);
        date.setMonth(date.getMonth() - mon);
        let monthName = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);
        return `${monthName}`;
    }

    getMonthlyReport = e => {
        const { AccountState } = this.props;
        const languageData = AccountState.account.SelectedlanguageData
        const { value } = e.target;
        if (this.state.selectedHotel) {
            let hotelId = this.state.selectedHotel;
            const newval = value == 0 ? 0 : value == 1 ? 1 : 2;

            let date = new Date();
            let startDate = new Date(date.getFullYear(), date.getMonth() - newval, 1);
            let endDate = new Date(date.getFullYear(), date.getMonth() - newval + 1, 0);
            const formData = {
                toDate: moment(endDate).format('YYYY-MM-DD') + "T23:59:59",
                fromDate: moment(startDate).format('YYYY-MM-DD') + "T00:00:00",
            }
            this.setState({ spinner: true })
            this.getAllData(formData, hotelId)

            this.setState({ fromDateReport: moment(startDate).format('yyyy-MM-DD'), toDate: moment(endDate).format('yyyy-MM-DD') + " " + "23:59", toDateReport: moment(endDate).format('yyyy-MM-DD'), month: value, hideReset: true });
        } else {
            Error((languageData && languageData.SELECT_A_HOTEL ? languageData.SELECT_A_HOTEL : "Select a hotel"));
        }
    }
    filterReset = (e) => {
        const account = this.props.AccountState.account;

        var today = new Date()
        var todayDate = moment(today).format("YYYY-MM-DD");

        this.setState({
            status: '',
            statusProgress: { label: "All", value: 0 },
            toDateReport: '',
            fromDateReport: todayDate,
            month: '',
            hideReset: false,
            spinner: true,
        });
        if (account.role == 'admin') {
            this.setState({ hotel: '', hotelName: '', selectedOption: '', selectedHotel: '' })
        }
        if (account.role != 'admin') {
            var hotelId = this.state.selectedHotel;
        } else {
            var hotelId = e.value
        }
        const formData = {
            fromDate: todayDate + "T00:00:00",
            toDate: '',
        }

        this.getAllData(formData, hotelId ? hotelId : '')

    }

    getAllData = (formData, hotel, queue = false) => {

        // this.setState({ selectedHotel: e.value, hotelName: e.label, toDateReport: '', month: '', selectedOption: e, hideReset: true, spinner: true, });
        axios.post(ImportedURL.API.getGuestReport + '/' + hotel, formData)
            .then((res) => {
                if (res.data.reviews != undefined && res.data.reviews.length == 0) {
                    this.setState({ emptyStatus: true })
                } else {
                    if (this.state.gridView)
                        this.setState({ emptyStatus: true })
                    else
                        this.setState({ emptyStatus: false })
                }
                if (res.data) {
                    const { total, seen, sent, nophone, repeated, invalidphone, noroom, blocklist, negativefeedbackstatus, google, tripadvisor, reviews, viewgooTripUrl, missingphone } = res.data
                    this.setState({
                        sent: sent, seen: seen, nophone, repeated, invalidphone, noroom, blocklist, total, reviews, spinner: false, missingphone,
                        series: [sent, seen, sent - seen, nophone, invalidphone, noroom, repeated, blocklist, missingphone]
                    })
                    this.setState({
                        google: google, tripadvisor: tripadvisor, negativefeedbackstatus: negativefeedbackstatus, viewgooTripUrl: viewgooTripUrl,
                        series1: [google, tripadvisor, negativefeedbackstatus]
                    })
                }
            }).catch((err) => {
                this.setState({ spinner: false, })
                console.log(err);
            });
        if (queue)
            axios.get(ImportedURL.API.getQueuelist + '/' + hotel, { params: { type: 'guesttouch' } })
                .then((res) => {
                    if (res.data) {
                        this.setState({
                            queuelist: res.data
                        })
                    }
                }).catch((err) => {
                    this.setState({ spinner: false, })
                    console.log(err);
                });
    }

    CancelRequest = (hotel, id) => {
        Swal.fire({
            title: 'Are you sure want to cancel review request?',
            showCancelButton: true,
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
            imageUrl: 'assets/images/delete.png',
            customClass: {
                popup: 'swal_pop',
                title: 'swal_title',
                image: 'swal_image',
                actions: 'swal_action',
                confirmButton: 'swal_confirm',
                cancelButton: 'swal_close',
            }
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post(ImportedURL.API.deleteQueue + '/' + hotel, {}, { params: { queueid: id, type: 'guesttouch' } })
                    .then((res) => {
                        if (res.data) {
                            this.setState({
                                queuelist: res.data
                            })
                            if (res.data.length == 0) this.setState({
                                queueshow: false
                            })
                        }
                    }).catch((err) => {
                        this.setState({ spinner: false })
                        console.log(err);
                    });
            }
        })

    }
    setStatus = (e) => {
        let hotelId = this.state.selectedHotel;

        const formData = {
            toDate: this.state.toDateReport ? this.state.toDateReport + "T23:59:59" : '',
            fromDate: this.state.fromDateReport ? this.state.fromDateReport + "T00:00:00" : '',
            status: e.value,
            statusfilter: true
        }

        this.setState({ status: e, gridView: true });
        axios.post(ImportedURL.API.getGuestReport + '/' + hotelId, formData)
            .then((res) => {
                if (res.data) {
                    this.setState({
                        reviews: res.data.reviews,
                    })
                }
            }).catch((err) => {
                this.setState({ spinner: false })
                console.log(err);
            });
    }


    SendAllRequest = (hotel, id) => {
        Swal.fire({
            title: 'Are you sure want to send review request?',
            showCancelButton: true,
            cancelButtonColor: '#d33',
            confirmButtonText: 'Send',
            imageUrl: '../../assets/images/invite.png',
            customClass: {
                popup: 'swal_pop',
                title: 'swal_title',
                image: 'swal_image',
                actions: 'swal_action',
                confirmButton: 'swal_confirm',
                cancelButton: 'swal_close',
            }
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post(ImportedURL.API.sendQueueGuestouch + '/' + hotel, {}, { params: { queueid: id } })
                    .then((res) => {
                        this.setState({ sendallbuttonshow: false })
                        if (res) {
                            setTimeout(() => {
                                const formData = {
                                    toDate: this.state.toDateReport ? this.state.toDateReport + "T23:59:59" : '',
                                    fromDate: this.state.fromDateReport ? this.state.fromDateReport + "T00:00:00" : ''
                                }
                                this.getAllData(formData, this.state.selectedHotel, true);
                                // res.sendStatus(200);
                            }, 15000);
                            this.setState({ queueshow: false })

                            Success("Sending messages please wait for some time...")
                        }
                    }).catch((err) => {
                        this.setState({ spinner: false })
                        console.log(err);
                        Error("Message not sent")
                    });
            }
        })
    }

    copyData = () => {
        let Date = moment(this.state.fromDateReport).format('MM/DD/YYYY')
        let value = `Today’s Departure List (${Date})` +
            `\n${this.state.hotelName}` +
            `\nTotal Departure             -${this.state.total}  Rooms` +
            `\nTotal Invite Sent           -${this.state.sent}  Rooms` +
            (this.state.repeated ? `\nRepeated Phone Number       -${this.state.repeated}  Rooms` : '') +
            (this.state.nophone ? `\nNo Phone Numbers provided   -${this.state.nophone}  Rooms` : '') +
            (this.state.noroom ? `\nCancelled Or No Status      -${this.state.noroom} Rooms` : '') +
            (this.state.invalidphone ? `\nInvalid Phone Number        -${this.state.invalidphone}  Rooms` : '') +
            (this.state.missingphone ? `\nMissing Phone Numbers       -${this.state.missingphone} Rooms` : '')

        navigator.clipboard.writeText(value);
        Swal.fire({ title: 'Copied', showConfirmButton: false, timer: 500 })
    }

    render() {
        const { HotelState, AccountState, LandingState } = this.props;
        const account = AccountState.account;
        const rowData = this.state.reviews;
        const listHotels = LandingState.landingdata && LandingState.landingdata.data && LandingState.landingdata.data.length > 1 ? LandingState.landingdata.data[0] : [];
        // const listHotels = HotelState.listhotels;
        const languageData = AccountState.account.SelectedlanguageData
        const viewfeedbackData = this.state.feedbackData;

        let percentage = '0';
        if (isNaN(this.state.sent) || isNaN(this.state.seen) || !this.state.sent || !this.state.seen) {
            percentage = "0";
        } else {
            percentage = ((this.state.seen / this.state.sent) * 100).toFixed(0);
        }
        const limitOptions = [
            { value: '25', label: '25' },
            { value: '50', label: '50' },
            { value: '100', label: '100' }
        ]
        var hotelOptionsSearch = [];
        if (listHotels.length > 1) {
            hotelOptionsSearch.push({ label: 'All', value: '', name: 'hotel' })
        }
        if (listHotels.length > 0) {
            listHotels.map(item => {
                if (account.role === 'admin') {
                    hotelOptionsSearch.push({ label: `${item.name} ${item.city} ${item.state}`, value: item._id, logo: item.logo, name: 'hotel' });
                } else {
                    hotelOptionsSearch.push({ label: `${item.name} ${item.city} ${item.state}`, value: item.hotelid, logo: item.logo, name: 'hotel' });
                }
            })
        }
        var selectedHotel = '';
        const hotelOptions = [];

        if (account?.allhotels?.length > 0) {
            account.allhotels.map((item) => {
                if (account.hotel == item.hotelid) {
                    selectedHotel = { label: `${item.name} ${item.city}  ${item.state}`, value: item.hotelid, logo: item.logo }
                }
                hotelOptions.push({ label: `${item.name} ${item.city}  ${item.state}`, value: item._id, logo: item.logo });
            })
        } else {
            listHotels.filter(filterItem => filterItem.status === true && filterItem.tripsadvisorurl && filterItem.googlereviewurl && filterItem.guesttouchid).map((item) => {
                hotelOptions.push({ label: `${item.name} ${item.city}  ${item.state}`, value: item._id, logo: item.logo, name: 'hotel' });
            })
        }


        // Pagination
        const { pagination, paginationLimit, startLimit, endLimit, queuelist, viewgooTripUrl, hotelName } = this.state;

        var totalNumber = Math.ceil(queuelist.length / paginationLimit);
        let queuelistsData = [];
        let endvalue = queuelist.length
        if (endLimit <= queuelist.length) {
            endvalue = endLimit
        }

        if (queuelist.length > 0) {
            for (let i = startLimit; i <= Number(endvalue); i++) {
                queuelistsData.push(queuelist[i - 1])
            }
        }

        const statusOptions = [
            { label: 'All', value: '', name: 'status' },
            { label: 'Opened', value: 'opened', name: 'status' },
            { label: 'Sent', value: 'valid', name: 'status' },
            { label: 'No phone number', value: 'nophone', name: 'status' },
            { label: 'Invalid phone number', value: 'invalidphone', name: 'status' },
            { label: 'Cancelled', value: 'noroom', name: 'status' },
            { label: 'Repeated phone number	', value: 'repeated', name: 'status' },
            { label: 'Block list', value: 'blocklist', name: 'status' },
        ];
        var tzone = 'America/chicago'
        if (account != undefined && account && account.tzone != undefined && account.tzone) {
            tzone = account.tzone
        }

        return (
            <>
                <div>
                    <div>
                        <div className="breadcrump">
                            <p> <Link to="/"><h6>{languageData && languageData.DASHBOARD ? languageData.DASHBOARD : "Dashboard"}</h6></Link>  <span><i className="fa fa-angle-right" aria-hidden="true"></i> </span>  <Link to="/guest-reports"><h6 className="highlights_breadcrump"> {languageData && languageData.GUEST_TOUCH_REPORT ? languageData.GUEST_TOUCH_REPORT : "Guest Touch Report"}</h6></Link></p>
                        </div>
                        <div className="section-body pt-3">
                            <div className='review_sec '>
                                <div className="container-fluid">
                                    <div className="tab-content">
                                        <div className="tab-pane fade show active" id="Departments-list" role="tabpanel">
                                            <div className="card">
                                                <div className="card-header top_title_icon">
                                                    <div className='rounded_icon'><i className="fa fa-list-alt mr-2"></i></div>
                                                    <h3 className="card-title top_title common_title_fs" style={{ fontWeight: 600 }}> {languageData && languageData.REPORTS ? languageData.REPORTS : "Reports"}{languageData && languageData.LIST ? languageData.LIST : ' List'}</h3>
                                                    <div className="card-options">
                                                        <div className="input-group">
                                                            {this.state.gridView ?
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <ul className="nav nav-tabs page-header-tab">
                                                                    </ul>
                                                                    {this.state.queueshow ?
                                                                        <button className='btn social_rest_btn btn-primarys mt-0 mr-3' style={{ height: "44px" }} type='button' onClick={() => { this.setState({ queueshow: !this.state.queueshow }) }}><i className={!this.state.queueshow ? "fa fa-navicon" : " fa fa-arrow-left"} aria-hidden="true" style={{ fontSize: '20px !importent', marginRight: '7px' }}></i> {this.state.queueshow ? 'Back' : 'In Queue'}</button> : ""
                                                                    }
                                                                    {this.state.queueshow ? "" :
                                                                        <>
                                                                            {rowData && rowData.length > 0 ?
                                                                                <>
                                                                                    <a className="btn btn-primary btn-sm nav-link dropdown-toggle export_btn_grid" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><i className="fa fa-download mr-2 " aria-hidden="true"></i>Export</a>
                                                                                    <div className="dropdown-menu">
                                                                                        <a className="dropdown-item" type='button' onClick={this.exportToCSV}><i className="dropdown-icon fa fa-file-excel-o"></i> Excel</a>
                                                                                        <a className="dropdown-item" type='button' onClick={this.exportPDF}><i className="dropdown-icon fa fa-file-pdf-o"></i> PDF</a>
                                                                                    </div>
                                                                                </> : ''}
                                                                        </>}
                                                                </div> : ''}
                                                            {!this.state.queueshow && account.role == 'admin' && !this.state.gridView ?
                                                                <Link to='overall-guestreports'><button className='btn social_rest_btn btn-primarys mt-0 mr-3' style={{ height: "44px" }} type='button'><i className="fa fa-navicon" aria-hidden="true" style={{ fontSize: '20px !importent', marginRight: '7px' }}></i> Overall Report</button> </Link> : ""
                                                            }
                                                            {!this.state.queueshow ?
                                                                <span className="input-group-btn ml-2">
                                                                    <button className="btn btn-sm btn-default" style={{ fontSize: "25px" }} onClick={() => { this.setState({ gridView: !this.state.gridView, emptyStatus: !this.state.emptyStatus }) }} >
                                                                        {this.state.gridView ? <span className="fa fa-bar-chart"></span> : <span className="fe fe-grid"></span>}
                                                                    </button>
                                                                </span>
                                                                : ''}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card'>
                                                <div className="card-body">
                                                    <div className="row">
                                                        {account.role == 'admin' ?
                                                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 ">
                                                                <div className="form-group">
                                                                    <label className="form-label">{languageData && languageData.SEARCH ? languageData.SEARCH : "Search"} {languageData && languageData.HOTEL ? languageData.HOTEL : "Hotel"} </label>
                                                                    {
                                                                        account.allhotels?.length > 0 ?
                                                                            <>
                                                                                <div style={{ display: 'block', alignItems: 'center' }}>
                                                                                    <img src={ImportedURL.FILEURL + selectedHotel.logo} style={{ height: '50px', width: '50px', borderRadius: "50%", marginRight: "20px", objectFit: 'contain' }} />
                                                                                    <span className='all_search_text_size'>{selectedHotel.label}</span>
                                                                                </div>
                                                                            </>
                                                                            :
                                                                            <>
                                                                                <Select
                                                                                    value={this.state.selectedOption}
                                                                                    name="hotel"
                                                                                    onChange={this.handleHotelChange}
                                                                                    options={hotelOptions}
                                                                                    formatOptionLabel={(e) => (
                                                                                        <div style={{ display: 'block', alignItems: 'center' }}>
                                                                                            <img src={ImportedURL.FILEURL + e.logo} className='all_search_image_size contain_image' />
                                                                                            <span className='all_search_text_size'>{e.label}</span>
                                                                                        </div>
                                                                                    )}
                                                                                    isDisabled={this.state.modalType == "View"}
                                                                                />
                                                                            </>
                                                                    }
                                                                </div>
                                                            </div>
                                                            : ''}
                                                        {!this.state.queueshow ?
                                                            <>
                                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12" style={this.state.queueshow ? { display: 'none' } : {}}>
                                                                    <div className="form-group">
                                                                        <label className="form-label">From Date</label>
                                                                        <div className='site_pass_calander'>
                                                                            <input type='date' className="form-control" name="fromDateReport" value={this.state.fromDateReport} onChange={this.setDateReport}></input>
                                                                            <i className="fa fa-calendar-check-o" style={{ cursor: 'pointer', fontSize: '20px', opacity: '0.7' }}></i>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12" style={this.state.queueshow ? { display: 'none' } : {}}>
                                                                    <div className="form-group">
                                                                        <label className="form-label">To Date</label>
                                                                        <div className='site_pass_calander'>
                                                                            <input type='date' className="form-control" name="toDateReport" min={this.state.fromDateReport ? this.state.fromDateReport : ''} onChange={this.setDateReport} value={this.state.toDateReport}></input>
                                                                            <i className="fa fa-calendar-check-o" style={{ cursor: 'pointer', fontSize: '20px', opacity: '0.7' }}></i>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 " style={this.state.queueshow ? { display: 'none' } : {}}>
                                                                    <div className="form-group">
                                                                        <label className="form-label">Archived Reports</label>
                                                                        <div className="selectgroup w-100">
                                                                            <label className="selectgroup-item">
                                                                                <input type="radio" name="month" className="selectgroup-input" value={0} onChange={this.getMonthlyReport} checked={this.state.month === '0'} />
                                                                                <span className="selectgroup-button first_month">{this.getMonths(0)}</span>
                                                                            </label>
                                                                            <label className="selectgroup-item">
                                                                                <input type="radio" name="month" className="selectgroup-input" value={1} onChange={this.getMonthlyReport} checked={this.state.month === '1'} />
                                                                                <span className="selectgroup-button">{this.getMonths(1)}</span>
                                                                            </label>
                                                                            <label className="selectgroup-item">
                                                                                <input type="radio" name="month" className="selectgroup-input" value={2} onChange={this.getMonthlyReport} checked={this.state.month === '2'} />
                                                                                <span className="selectgroup-button last_month">{this.getMonths(2)}</span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 " style={this.state.queueshow || !this.state.gridView ? { display: 'none' } : {}}>
                                                                    <label className="form-label">Status</label>
                                                                    <div className="form-group">
                                                                        <Select
                                                                            value={this.state.status}
                                                                            onChange={this.setStatus}
                                                                            options={statusOptions}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </>
                                                            : ''}
                                                        <div className='col-xl-3 col-lg-3'>
                                                            <div className='row' style={{ marginTop: '27px' }}>
                                                                {!this.state.queueshow ?
                                                                    <div className={"col-xl-6 col-lg-6 col-md-3 col-sm-6 col-12 d-flex align-items-center pr-0"} >
                                                                        <div >
                                                                            {
                                                                                this.state.hideReset ?
                                                                                    <div>
                                                                                        <button style={{ width: '110px', letterSpacing: '1px' }} className='btn social_rest_btn btn-primarys mt-0' type='button' onClick={this.filterReset}><i className="fa fa-refresh" aria-hidden="true" style={{ fontSize: '20px !importent', marginRight: '7px' }}></i> Reset</button>
                                                                                    </div>
                                                                                    : ''
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    : ''}
                                                                <div className={"col-xl-6 col-lg-6 col-md-3 col-sm-6 col-12 d-flex pl-0"} style={!this.state.queueshow ? { paddingLeft: '0px' } : {}}>
                                                                    {this.state.gridView && this.state.queuelist.length ?
                                                                        <div >
                                                                            {!this.state.queueshow ? <button className='btn social_rest_btn btn-primarys mt-0' type='button' onClick={() => { this.setState({ queueshow: !this.state.queueshow }) }}><i className="fa fa-navicon" aria-hidden="true" style={{ fontSize: '20px !importent', marginRight: '7px' }}></i> {this.state.queueshow ? 'Back' : 'In Queue'}</button> : ''}
                                                                            {this.state.queueshow &&
                                                                                <div>
                                                                                    <button className="btn btn-danger" type="button" style={{ height: '38px', fontSize: '16px', fontWeight: 500, borderRadius: '10px', background: '#d45050' }} onClick={() => this.CancelRequest(this.state.selectedHotel)}><i class="fa fa-close" aria-hidden="true" ></i> Cancel All</button>

                                                                                    {/* {this.state.sendallbuttonshow ?
                                                                                        <button className="btn btn-danger" type="button" style={{
                                                                                            backgroundColor: '#1B3078', position: 'absolute', left: 130, right: -100, height: '38px', fontSize: '16px', fontWeight: 500, borderRadius: '10px',
                                                                                        }} onClick={() => this.SendAllRequest(this.state.selectedHotel)}><i class="fa fa-send" aria-hidden="true" ></i> Send All</button>
                                                                                        : ''} */}
                                                                                </div>
                                                                            }
                                                                        </div> : ''}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {!this.state.gridView ?
                                                        <>
                                                            {(this.state.total !== 0 || this.state.seen !== 0 || this.state.sent !== 0 || this.state.nophone !== 0 || this.state.invalidphone !== 0 || this.state.noroom !== 0 || this.state.repeated !== 0 || this.state.blocklist !== 0) ?
                                                                <div className="row clearfix row-deck " style={!this.state.selectedHotel ? { display: 'none' } : {}}>
                                                                    <div className=" card_body_report">
                                                                        <div className="col-xl-12 col-lg-12 col-md-12 ">
                                                                            <div className='all_invites_flex'>
                                                                                <div>
                                                                                    <h3 className="card-title title_color_report">All Invites</h3>
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-xl-6 col-lg-6 col-md-6">
                                                                        <div className="card report_table_open_count">
                                                                            <div className="row text-center">
                                                                                <div className="col-sm-12 ">
                                                                                    <div className="table-responsive">
                                                                                        <table className="table table-striped table-vcenter mb-0">
                                                                                            <thead>
                                                                                                <tr >
                                                                                                    <th className="tx-medium text-left">Total<span style={{ cursor: 'pointer' }} onClick={this.copyData}><i class="fa fa-clone ml-2" data-action-type="Copyemail"></i></span></th>
                                                                                                    <th className="text-right">{this.state.total}</th>
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody>
                                                                                                <tr>
                                                                                                    <td className="tx-medium text-left"><a type='button' style={{ color: '#1B3078' }} onClick={() => { this.setStatus({ label: 'Opened', value: 'opened', name: 'status' }) }}>Opened</a></td>
                                                                                                    <td className="text-right">{this.state.seen}</td>
                                                                                                </tr>
                                                                                                <tr>
                                                                                                    <td className="tx-medium text-left"><a type='button' style={{ color: '#1B3078' }} onClick={() => { this.setStatus({ label: 'Sent', value: 'valid', name: 'status' }) }}>Sent</a></td>
                                                                                                    <td className="text-right">{this.state.sent}</td>
                                                                                                </tr>
                                                                                                {this.state.nophone ? <tr>
                                                                                                    <td className="tx-medium text-left">No Phone Numbers provided</td>
                                                                                                    <td className="text-right">{this.state.nophone}</td>
                                                                                                </tr> : ''}
                                                                                                {this.state.invalidphone ? <tr>
                                                                                                    <td className="tx-medium text-left">Invalid Phone Number</td>
                                                                                                    <td className="text-right">{this.state.invalidphone}</td>
                                                                                                </tr> : ''}
                                                                                                {this.state.noroom ? <tr>
                                                                                                    <td className="tx-medium text-left">Cancelled Or No Status</td>
                                                                                                    <td className="text-right">{this.state.noroom}</td>
                                                                                                </tr> : ''}
                                                                                                {this.state.repeated ? <tr>
                                                                                                    <td className="tx-medium text-left">Repeated Phone Number</td>
                                                                                                    <td className="text-right">{this.state.repeated}</td>
                                                                                                </tr> : ''}
                                                                                                {this.state.blocklist ? <tr>
                                                                                                    <td className="tx-medium text-left">Block list</td>
                                                                                                    <td className="text-right">{this.state.blocklist}</td>
                                                                                                </tr> : ''}
                                                                                                {this.state.missingphone ? <tr>
                                                                                                    <td className="tx-medium text-left">Missing Phone Numbers </td>
                                                                                                    <td className="text-right">{this.state.missingphone}</td>
                                                                                                </tr> : ''}
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                </div>
                                                                                {/* <div className="col-sm-4"><label className="mb-0">Interaction Rate</label><h4 className="font-30 font-weight-bold text-col-blue counter"><span>{percentage}%</span></h4></div> */}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-xl-6 col-lg-6 col-md-6">
                                                                        <div className="card">
                                                                            <div className="row">
                                                                                <div className="col-sm-12 pb-4 pt-1">
                                                                                    <Chart options={this.state.options} series={this.state.series} type="pie" />
                                                                                </div>
                                                                                <div className="col-sm-12 text-center pt-2"><label className="mb-0">Interaction Rate</label><h4 className="font-30 font-weight-bold text-col-blue counter"><span>{percentage}%</span></h4></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        (this.state.negativefeedbackstatus != 0 || this.state.tripadvisor != 0 || this.state.google != 0 || this.state.seen != 0)
                                                                            ?
                                                                            <>
                                                                                <div className="col-xl-6 col-lg-6 col-md-6" style={{ marginTop: "30px" }}>
                                                                                    <div className="card report_table_open_count">
                                                                                        <div className="row text-center">
                                                                                            <div className="col-sm-12 ">
                                                                                                <div className="table-responsive">
                                                                                                    <table className="table table-striped table-vcenter mb-0">
                                                                                                        <thead>
                                                                                                            <tr >
                                                                                                                <th className="tx-medium text-left">Total opened Invites</th>
                                                                                                                <th className="text-right">{this.state.seen}</th>
                                                                                                            </tr>
                                                                                                        </thead>
                                                                                                        <tbody>
                                                                                                            <tr>
                                                                                                                <td className="tx-medium text-left">Completed with {viewgooTripUrl && viewgooTripUrl.googlereviewviewurl != undefined ? <a href={viewgooTripUrl && viewgooTripUrl.googlereviewviewurl != undefined ? viewgooTripUrl.googlereviewviewurl : ''} target='_blank' style={{ fontWeight: '500' }}>google</a> : "google"} </td>
                                                                                                                <td className="text-right">{this.state.google}</td>
                                                                                                            </tr>
                                                                                                            <tr>
                                                                                                                <td className="tx-medium text-left">Completed with {viewgooTripUrl && viewgooTripUrl.tripsadvisorviewurl != undefined ? <a href={viewgooTripUrl && viewgooTripUrl.tripsadvisorviewurl != undefined ? viewgooTripUrl.tripsadvisorviewurl : ''} target='_blank' style={{ fontWeight: '500' }}>tripadvisor</a> : "tripadvisor"}</td>
                                                                                                                <td className="text-right">{this.state.tripadvisor}</td>
                                                                                                            </tr>
                                                                                                            <tr>
                                                                                                                <td className="tx-medium text-left">Negative feedback</td>
                                                                                                                <td className="text-right">{this.state.negativefeedbackstatus}</td>
                                                                                                            </tr>

                                                                                                        </tbody>
                                                                                                    </table>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                {
                                                                                    (this.state.negativefeedbackstatus != 0 || this.state.tripadvisor != 0 || this.state.google != 0)
                                                                                    &&
                                                                                    <div className="col-xl-6 col-lg-6 col-md-6" style={{ marginTop: "20px" }}>
                                                                                        <div className="card">
                                                                                            <div className="row">
                                                                                                <div className="col-sm-12">
                                                                                                    <Chart options={this.state.options1} series={this.state.series1} type="pie" />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                }
                                                                            </>
                                                                            : ""
                                                                    }
                                                                </div>

                                                                :
                                                                <div className="card" style={{ height: '455px' }}>
                                                                    <div className="card-header pt-0">
                                                                        <div className="card-body no_records text-center d-flex align-items-center justify-content-center pt-0">
                                                                            <div style={{ maxWidth: "340px" }}>
                                                                                <img src="../assets/images/nothing-here.png" alt="..." className="img-fluid" style={{ maxWidth: "272px" }} />
                                                                                <h5 className="mb-2">No records to display </h5>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </>
                                                        :
                                                        <div className="table-responsive pt-3" style={this.state.queueshow ? { display: 'none' } : {}}>
                                                            <div className="ag-theme-alpine">
                                                                <AgGridReact
                                                                    rowHeight={82}
                                                                    paginationPageSize={25}
                                                                    pagination={true}
                                                                    onRowClicked={this.onRowClicked}
                                                                    domLayout={"autoHeight"}
                                                                    defaultColDef={this.state.defaultColumDef}
                                                                    onGridReady={this.onGridReady}
                                                                    rowData={rowData}
                                                                    overlayNoRowsTemplate={"No rows to display"}
                                                                    columnDefs={this.state.columnDefs}>
                                                                </AgGridReact>
                                                            </div>
                                                        </div>
                                                    }

                                                    <div className="table-responsive pt-3" style={this.state.queueshow ? {} : { display: 'none' }}>
                                                        <div className="ag-theme-alpine">
                                                            <AgGridReact
                                                                rowHeight={82}
                                                                paginationPageSize={25}
                                                                pagination={true}
                                                                onRowClicked={this.onRowClicked}
                                                                domLayout={"autoHeight"}
                                                                defaultColDef={this.state.defaultColumDef2}
                                                                onGridReady={this.onGridReady}
                                                                rowData={this.state.queuelist}
                                                                overlayNoRowsTemplate={"No rows to display"}
                                                                columnDefs={this.state.columnDefs2}>
                                                            </AgGridReact>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>


                                        </div>

                                        <div className="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                            <div className="modal-dialog latest_review_modal" role="document">
                                                <div className="modal-content">
                                                    <div className="modal-header">
                                                        <h5 className="modal-title" id="exampleModalLabel">View Feedback</h5>
                                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                            <span aria-hidden="true" style={{ fontSize: "24px" }}>x</span>
                                                        </button>
                                                    </div>
                                                    <div className="modal-body">
                                                        <div className="modal-body">
                                                            <article className="media">
                                                                <div className="mr-3">
                                                                    <img className="avatar avatar-xl" src={viewfeedbackData.hotel && viewfeedbackData.hotel.logo ?
                                                                        ImportedURL.FILEURL + viewfeedbackData.hotel.logo : 'assets/images/defaultuser.png'}
                                                                        onError={(e) => { if (e.target.src !== "assets/images/defaultuser.png") { e.target.onerror = null; e.target.src = ImportedURL.LOCALURL + "assets/images/defaultuser.png"; } }} alt=""
                                                                    />
                                                                </div>
                                                                <div className="media-body">
                                                                    <div className="content">
                                                                        <p className="h5"><span className='pr-2'>{viewfeedbackData.name}</span>
                                                                            <small className="float-right text-muted">{viewfeedbackData.date_text_sent ? moment(viewfeedbackData.date_text_sent).format("MM/DD/yyyy hh:mm A") : ''}</small>
                                                                        </p>
                                                                        <p>
                                                                            <small className='pt-2'>{viewfeedbackData.phone}</small>
                                                                            <small className="float-right text-muted">{viewfeedbackData.hotel ? `${viewfeedbackData.hotel.name} ${viewfeedbackData.hotel.city} ${viewfeedbackData.hotel.state}` : ''}</small>
                                                                        </p>
                                                                        <p dangerouslySetInnerHTML={{ __html: viewfeedbackData.feedback_text }} className="mt-3"></p>
                                                                    </div>
                                                                </div>
                                                            </article>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="overlay" style={{ display: this.state.spinner ? 'block' : 'none' }}></div>
                    {
                        this.state.spinner &&
                        <div className='common_loader'>
                            <img className='loader_img_style_common' src='../../assets/images/load.png' />
                            <Spinner className='spinner_load_common' animation="border" variant="info" >
                            </Spinner>
                        </div>
                    }

                </div >
            </>
        )
    }
}
const mapStateToProps = state => ({
    fixNavbar: state.settings.isFixNavbar,
    ReviewState: state.review,
    AccountState: state.account,
    HotelState: state.hotel,
    RoomState: state.room,
    LandingState: state.landing,
})

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        ListRoom: AC_LIST_ROOM,
        ListFeedback: AC_LIST_FEEDBACK
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(ListFeedback);